/* eslint-disable jam3/no-sanitizer-with-danger */

import { withStyles } from '@material-ui/core/styles'

import Tooltip from '@material-ui/core/Tooltip'
import React from 'react'

const arrowGenerator = color => ({
  '&[x-placement*="bottom"]': {
    marginTop: '8px',
    '& $arrow': {
      top: 0,
      left: 0,
      marginTop: '-6px',
      width: '1rem',
      height: '1rem',
      '&::before': {
        borderWidth: '0 1em 1em 1em',
        borderColor: `transparent transparent ${color} transparent`,
      },
    },
  },
  '&[x-placement*="top"]': {
    marginBottom: '8px',
    '& $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: '-16px',
      width: '1rem',
      height: '1rem',
      '&::before': {
        borderWidth: '1em 1em 0 1em',
        borderColor: `${color} transparent transparent transparent`,
      },
    },
  },
  '&[x-placement*="right"]': {
    marginLeft: '8px',
    '& $arrow': {
      left: 0,
      marginLeft: '-6px',
      height: '1rem',
      width: '1em',
      '&::before': {
        borderWidth: '1em 1em 1em 0',
        borderColor: `transparent ${color} transparent transparent`,
      },
    },
  },
  '&[x-placement*="left"]': {
    marginRight: '8px',
    '& $arrow': {
      right: 0,
      marginRight: '-11px',
      height: '1rem',
      width: '1rem',
      '&::before': {
        borderWidth: '1em 0 1em 1em',
        borderColor: `transparent transparent transparent ${color}`,
      },
    },
  },
})

const styles = theme => ({
  arrowPopper: arrowGenerator(theme.colors.navy),
  arrow: {
    position: 'absolute',
    fontSize: 6,
    width: '1rem',
    height: '1rem',
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
    },
  },
  tooltip: {
    padding: '1rem',
    backgroundColor: `var(--gameday-navBar-navTooltipBg, ${theme.navBar.navTooltipBg})`,
    fontSize: theme.typography.fontSizeTinyish,
    margin: 0,
  },
})

class CustomTooltip extends React.Component {
  state = {
    arrowRef: null,
  }

  handleArrowRef = node => {
    this.setState({
      arrowRef: node,
    })
  }

  render() {
    const { children, classes, content, placement, setTooltipDangerously } = this.props
    const { arrowRef } = this.state
    return (
      <Tooltip
        title={
          <>
            {/** biome-ignore lint/security/noDangerouslySetInnerHtml: TODO */}
            {setTooltipDangerously ? <p dangerouslySetInnerHTML={{ __html: content }} /> : content}
            <span className={classes.arrow} ref={this.handleArrowRef} />
          </>
        }
        classes={{
          popper: classes.arrowPopper,
          tooltip: classes.tooltip,
        }}
        disableTouchListener
        placement={placement}
        PopperProps={{
          popperOptions: {
            modifiers: {
              arrow: {
                enabled: Boolean(arrowRef),
                element: arrowRef,
              },
            },
          },
        }}
      >
        {children}
      </Tooltip>
    )
  }
}

const TooltipComponent = withStyles(styles)(CustomTooltip)
TooltipComponent.displayName = 'Tooltip'
export default TooltipComponent
